var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburgerMenu py-1 px-2",class:{ opened : _vm.value && _vm.animated },on:{"click":_vm.toggle}},[_c('div',{staticClass:"bar1"}),_c('div',{staticClass:"bar2"}),_c('div',{staticClass:"bar3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }